/** Review collage files in `frontend/public/reviews/` → URLs `/reviews/01.jpg` … */
export const REVIEW_PHOTO_PUBLIC_DIR = "reviews";
export const REVIEW_PHOTO_COUNT = 20;
export const REVIEW_PHOTO_EXT = "jpg";
